var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"height":"24px","max-height":"24px","width":"24px","max-width":"24px","contain":"","src":_vm.path}})}
var staticRenderFns = []

export { render, staticRenderFns }